<template>
  <div class="sucess">
      <div class="suc">
        <img class='close' src="../../static/images/closeicon.png" alt="" @click='cancel'>
        <p class='custserver'>专业旅游顾问，为您提供专享服务</p>
        <div class="ewm">
            <img :src="kfcode" alt="">
            <p class='ewmword'>微信扫码 联系我们</p>
        </div>
        <input type="text" class='int' placeholder="输入您的姓名" v-model="form.consultName">
        <input type="text" class='int num' placeholder="输入您的手机号码" v-model="form.tel"  @blur='refsh()' maxlength=11>
         <div class="flex">
            <input class='yzm' v-model="form.code" placeholder="请输入验证码"/>
            <img class='yzmimg' :src='vcode' alt="">
            <div class="refsh" @click='refsh'>点击刷新图片</div>
        </div>
        <div class='tjline' @click='ask'>立即咨询</div>
        <p class='smword'>您也可以留下您的手机号码，我们可以联系您</p>
    </div>
    <Waring v-show='waringshow' :waring='waringword'></Waring>
    <Sucess :sucess = 'sucess' v-show = 'sucessshow'></Sucess>
  </div>
</template>
<script>
import kf from '../../assets/img/code.png'
import Waring from '@/components/warning/warning'
import Sucess from '@/components/sucess/ordersucess'
import {consult} from '@/api/ship.js'
import {baseset} from '@/api/header.js'
export default {
  components: {
    Sucess,
    Waring
  },
  data () {
    return {
      vcode: '',
      form: {
        consultName: '',
        tel: '',
        code: ''
      },
      waringshow: false,
      waringword: '',
      sucess: '提交成功，我们将安排专员尽快与您联系！',
      sucessshow: false,
      kfcode: kf
    }
  },
  created () {
    this.refsh()
    this.baseset()
  },
  methods: {
    cancel () {
      this.$parent.cancel()
      this.sucessshow = false
    },
    // 刷新验证码
    refsh () {
      if (this.form.tel.length > 0) {
        let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!myreg.test(this.form.tel)) {
          this.waringword = '请输入正确手机号'
          this.waringshow = true
          setTimeout(() => { this.waringshow = false }, 1000)
          return
        }
      }
      this.vcode = 'https://www.tripolers.com.cn/admin/vcode/vcode?tel=' + this.form.tel + '&notime' + Math.random()
    },
    // 二维码
    baseset () {
      baseset().then(res => {
        this.kfcode = res.data.data.kfcode
      })
    },
    // 立即咨询
    ask () {
      if (this.form.consultName.length === 0) {
        this.waringword = '请输入您得姓名!'
        this.waringshow = true
        setTimeout(() => { this.waringshow = false }, 1000)
        return
      }
      if (this.form.code.length === 0) {
        this.waringword = '请输入验证码'
        this.waringshow = true
        setTimeout(() => { this.waringshow = false }, 1000)
        return
      }
      consult(this.form).then(res => {
        if (res.data.errno === 0) {
          this.sucessshow = true
        } else {
          this.waringword = '验证码错误，重新输入'
          this.waringshow = true
          setTimeout(() => { this.waringshow = false }, 1000)
        }
      })
    }
  }
}
</script>
<style scoped>
.sucess{
    display:flex;
    justify-content: center;
    align-items: center;
    width:100%;
    height:100%;
    background-color:rgba(0,0,0,.5);
    position:fixed;
    top:0;
    left:0;
  }
  .suc{
    color:#434F55;
    font-size: 1.25rem;
    font-weight:500;
    width:428px;
    background:rgba(255,255,255,1);
    border-radius:2px;
    position: relative;
    padding-bottom: 12px;
  }
  .close{
    width:1.0625rem;
    height: 1.0625rem;
    position: absolute;
    top:.875rem;
    right:.875rem;
  }
  .word{
    font-size:20px;
    font-weight:500;
    color:rgba(67,79,85,1);
    text-align: center;
    margin-top:22px;
  }
  .tjline{
    display: block;
    width:389px;
    height:46px;
    background:rgba(1,163,223,1);
    border-radius:4px;
    text-align:center;
    line-height:46px;
    font-size:20px;
    font-family:SourceHanSansCN;
    font-weight:500;
    color:#fff;
    text-decoration: none;
    margin:auto;
    margin-top:10px;
  }
  .smword{
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(122,131,136,1);
    margin-top:9px;
     text-align: center;
  }
  .custserver{
    font-size:20px;
    font-weight:500;
    color:rgba(1,163,223,1);
    text-align: center;
    margin-top:28px;
  }
.ewm{
    width:195px;
    height:225px;
    background:url('../../static/images/ewmbk.png');
    margin:auto;
    margin-top:27px;
}
.ewm img{
    width:164px;
    height:165px;
    margin:16px

}
.ewmword{
    font-size:14px;
    font-weight:300;
    color:rgba(147,154,158,1);
    text-align: center;
}
.int{
    display:block;
    width:389px;
    height:43px;
    line-height: 43px;
    background:rgba(248,250,251,1);
    border:1px solid rgba(205, 209, 215, 1);
    border-radius:4px;
    margin:auto;
    font-size:14px;
    font-weight:300;
    color:rgba(147,154,158,1);
    margin-top:26px;
    text-align: center;
}
.flex{
    display:flex;
    justify-content: space-between;
    align-items: center;
    width:389px;
    margin:auto;
    margin-top:10px;
}
.yzm{
    width:170px;
    height:43px;
    line-height: 43px;
    background:rgba(248,250,251,1);
    border:1px solid rgba(205, 209, 215, 1);
    border-radius:4px;
    font-size:14px;
    font-weight:300;
    color:rgba(147,154,158,1);
    text-align: center;
}
.yzmimg{
    height:43px;
}
.refsh{
    line-height:40px;
    color:rgba(122,131,136,1);
    font-size: 14px;
    cursor:default;
}
.num{
  margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/book/book.vue